/**
 * Browser-compatible version of Node.js path.relative()
 * Returns the relative path from 'from' to 'to'
 */
export function pathRelative(from: string, to: string): string {
  // Normalize paths by removing trailing slashes and handling empty strings
  from = normalizePath(from || ".");
  to = normalizePath(to || ".");

  // If paths are identical, return empty string
  if (from === to) return "";

  // Split paths into segments
  const fromSegments = from.split("/").filter((segment) => segment !== "");
  const toSegments = to.split("/").filter((segment) => segment !== "");

  // Find common base
  let commonLength = 0;
  const minLength = Math.min(fromSegments.length, toSegments.length);

  for (let i = 0; i < minLength; i++) {
    if (fromSegments[i] === toSegments[i]) {
      commonLength++;
    } else {
      break;
    }
  }

  // Calculate relative path
  const upCount: number = fromSegments.length - commonLength;
  const downSegments: string[] = toSegments.slice(commonLength);

  // Build result
  const result: string[] = [];

  // Add '../' for each level up
  for (let i = 0; i < upCount; i++) {
    result.push("..");
  }

  // Add remaining path segments
  result.push(...downSegments);

  return result.join("/") || ".";
}

/**
 * Helper function to normalize paths
 */
function normalizePath(path: string): string {
  // Convert backslashes to forward slashes
  path = path.replace(/\\/g, "/");

  // Remove trailing slash (except for root)
  if (path.length > 1 && path.endsWith("/")) {
    path = path.slice(0, -1);
  }

  // Handle relative path indicators
  const segments: string[] = path.split("/");
  const normalized: string[] = [];

  for (const segment of segments) {
    if (segment === "" || segment === ".") {
      // Skip empty segments and current directory references
      continue;
    } else if (segment === "..") {
      // Go up one directory
      if (normalized.length > 0 && normalized[normalized.length - 1] !== "..") {
        normalized.pop();
      } else {
        normalized.push("..");
      }
    } else {
      normalized.push(segment);
    }
  }

  return normalized.join("/") || ".";
}
